import styled from "styled-components";

export const OptionWrapper = styled.div`
  display: block;
  @media (max-width: 760px) {
    display: none;
  }
`;
